import EntranceClassic from './EntranceClasssic';
import EntranceStationery from './EntranceStationery';

export const ENTRANCES = {
    classic: EntranceClassic,
    stationery: EntranceStationery,
};